import { makeActionCreator } from '../../../redux-util/general-helpers';
import { getCurrentScaledZoom, getZoomScalingFactor } from './selectors';
import { setRawZoom } from '../../../redux-jigsaw/zoom/actions';
import { getCurrentRawZoom } from '../../../redux-jigsaw/zoom/selectors';
import { isFixedLayout } from '../../../redux-jigsaw/jigsaw-selectors';
import {
  disableScrolling,
  enableScrolling,
  scrollToLeft,
  scrollToTop,
} from '../../../redux-jigsaw/jigsaw-action';

export const toggleFullScreen = makeActionCreator(
  'ui.common.reader.toggleFullScreen'
);
export const setFullScreen = makeActionCreator(
  'ui.common.reader.setFullScreen'
);

/**
 * Zoom of 1 * scaling factor = raw zoom needed to fill visible area
 */
export const setZoomScalingFactor = makeActionCreator(
  'ui.common.reader.setZoomScalingFactor',
  'data'
);

/**
 * val of 1 = fill visible area
 */
export function setZoomWithScaleFactor(val) {
  return function(dispatch, getState) {
    const factor = getZoomScalingFactor(getState());
    dispatch(setRawZoom(val * factor));
  };
}

function setZoomScaleFactor(factor) {
  return function(dispatch, getState) {
    const oldFactor = getZoomScalingFactor(getState());
    const rawZoom = getCurrentRawZoom(getState());
    const oldScaledZoom = rawZoom / oldFactor;
    dispatch(setZoomScalingFactor(factor));
    dispatch(setRawZoom(oldScaledZoom * factor));
  };
}

/**
 * Update the scaling factor and re-zoom the page to compensate.
 * Runs only on change
 */
export function updateZoomScaleFactor(factor) {
  return function(dispatch, getState) {
    const oldFactor = getZoomScalingFactor(getState());
    if (oldFactor !== factor) {
      dispatch(setZoomScaleFactor(factor));
    }
  };
}

/**
 * Force a re-zoom of the current page
 */
export function refreshZoom() {
  return function(dispatch, getState) {
    const currentFactor = getZoomScalingFactor(getState());
    dispatch(setZoomScaleFactor(currentFactor));
  };
}

export function updateScrolling() {
  return function(dispatch, getState) {
    if (isFixedLayout(getState())) {
      const zoom = getCurrentScaledZoom(getState());
      if (zoom === 1) {
        dispatch(scrollToTop());
        dispatch(scrollToLeft());
        dispatch(disableScrolling());
      } else {
        dispatch(enableScrolling());
      }
    } else {
      dispatch(enableScrolling());
    }
  };
}
